import './OffersImport.css';
import CloseModal from '../../CommonFunctions/closeModal';
import FloatingLoading from '../FloatingLoading/FloatingLoading';
import dataBase from '../../../../config';
import { useState } from 'react';
import { useAtom } from 'jotai';
import { ref as AddOfferRef, set, get, child, increment } from "firebase/database";
import { useLoggedUser, useShowPopUpModal, useModalVersion, useModalInfo, useMainFilter } from '../../../../data/GlobalStates';

const OffersImport = ({set, db, PopUpModalRef }) => {
  // stany globalne
  const [LoggedUser] = useAtom(useLoggedUser);
  const [ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
  const [ModalVersion, setModalVersion] = useAtom(useModalVersion);
  const [ModalInfo, setModalInfo] = useAtom(useModalInfo);
  const [MainFilter, setMainFilter] = useAtom(useMainFilter);

  // stany lokalne
  const [ID, setID] = useState('');
  const [Token, setToken] = useState('');
  const [Warning, setWarning] = useState('');
  const [ImportedOffers, setImportedOffers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [statuses, setStatuses] = useState([0]);
  const [DownLoading, setDownLoading] = useState(false);

  const dbRef = AddOfferRef(dataBase);// DO ODCZYTU

        const date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDay();   

        const statusOptions = [
        { label: 'Aktywna wewnętrzna', value: 99 },
        { label: 'Aktywna publikacja', value: 0 },
        { label: 'Bez statusu', value: 1 },
        { label: 'Negocjacje', value: 4 },
        { label: 'Robocza', value: 52 },
       ];


  const DownloadOffersFunction = async () => {
    const allOffers = [];
    setDownLoading(true)

    for (const status of statuses) {
      const url = `https://app.esticrm.pl/apiClient/offer/list?company=${encodeURIComponent(ID)}&token=${encodeURIComponent(Token)}&status=${status}`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Błąd HTTP: ${response.status}`);
        }

        const data = await response.json();

        if (data.message === 'Brak uprawnień.') {
          setWarning('Nieprawidłowe dane');
          setDownLoading(false)
          setTimeout(() => setWarning(''), 5000);
          return;
        } else if (data.message === 'Brak ustawień API w ErstiCRM') {
          setWarning('API nie aktywowane, skontaktuj się z pomoc@esticrm.pl w celu aktywacji');
          setDownLoading(false)
          setTimeout(() => setWarning(''), 15000);
          return;
        } else if (data.success === true && data.data === false) {
          continue;
        } else if (data.success === true) {
          if (Array.isArray(data.data)) {
            allOffers.push(...data.data);
          } else if (data.data) {
            allOffers.push(data.data);
            setDownLoading(false)
          }
        }
      } catch (error) {
        setWarning(`Błąd pobierania: ${error}, Daj nam chwile zbadamy problem`);
        setDownLoading(false)
        setTimeout(() => setWarning(''), 10000);
        set(PopUpModalRef(db, `errors/${year}/${month}/${day}/DownloadOffersFunction`), error) // here
      }
    }

    if (allOffers.length === 0) {
      setWarning('Brak ofert do pobrania');
      setDownLoading(false)
      setTimeout(() => setWarning(''), 10000);
    } else {
      setImportedOffers(allOffers);
      setDownLoading(false)
    }
  };

  const handleIDInputChange = (e) => setID(e.target.value);
  const handleTokenInputChange = (e) => setToken(e.target.value);

  const DownloadOffers = () => {
    if (ID && Token) {
      DownloadOffersFunction();
    } else {
      setWarning('Uzupełnij ID oraz Token');
      setTimeout(() => setWarning(''), 3000);
    }
  };

  const toggleOfferSelection = (offerId) => {
    const updated = ImportedOffers.map((offer) =>
      offer.id === offerId ? { ...offer, selectedToImport: !offer.selectedToImport } : offer
    );
    setImportedOffers(updated);
    console.log(updated)
  };

  const selectAllOffers = () => {
    const updated = ImportedOffers.map((offer) => ({ ...offer, selectedToImport: true }));
    setImportedOffers(updated);
    console.log(updated)
  };

    const deSelectAllOffers = () => {
    const updated = ImportedOffers.map((offer) => ({ ...offer, selectedToImport: false }));
    setImportedOffers(updated);
    console.log(updated)
  };

  const PicturesDisplayer = (Images, item) => {
    const images = Array.isArray(Images) ? Images : [];
    if (!images.length) return <p>Brak zdjęć do wyświetlenia.</p>;

    return (
      <div className="carousel-container">
        <img
          src={images[currentIndex]}
          alt={`Zdjęcie oferty: ${item.portalTitle || ''}`}
          className="SingleImportedOfferCarouselImage"
        />
      </div>
    );
  };

  const CalcSingleOfferPrice = (num) => {
    if (typeof num !== 'string' && typeof num !== 'number') return null;
    const stringValue = num.toString().split('.')[0];
    const cleaned = stringValue.replace(/\D/g, '');
    const numericValue = parseInt(cleaned, 10);
    if (isNaN(numericValue)) return null;
    const formatted = numericValue.toLocaleString('pl-PL').replace(/,/g, ' ');
    return `${formatted} zł`;
  };

  function fortmatPrice(value) {
  return Math.floor(Number(value));
}

  function fortmatMarket(value) {
  if (value === 11) {
    return "Wtórny"
  } else return "Pierwotny"
};

function trimMainCat(text) {
  return text.replace(/\s*\(.*?\)\s*/g, '').trim();
};

function trimSubCat(text) {
  if (typeof text !== 'string') return null; // zabezpieczenie na wejściu

  const match = text.match(/\(([^)]*)\)/); // poprawiony regex
  if (match && typeof match[1] === 'string' && match[1].trim().length > 0) {
    return match[1].trim();
  }

  return null;
};

function trimParking(offer) {
  if (offer.additionalParkingunderground == 1) {
    return "W hali garażowej"
  } else if (offer.additionalParking == 1 ) {
      return "Ogólnodostępne"
  }
}


const saveImportedOffersDailyStats = async (number) => {
  const pad = (n) => String(n).padStart(2, '0');
  const date = new Date(); // Dodane, bo nie było wcześniej
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  try {
    const statSnap = await get(child(dbRef, `stats/offersDailyImportsCounter/${year}/${month}/${day}/offers`));

    const offersRef = PopUpModalRef(db, `stats/offersDailyImportsCounter/${year}/${month}/${day}/offers`);

    if (!statSnap.exists()) {
      // Jeśli brak danych – ustaw wartość startową
      await set(offersRef, number);
    } else {
      // Jeśli dane istnieją – inkrementuj o podaną liczbę
      await set(offersRef, increment(number));
    }
  } catch (error) {
    const errorRef = PopUpModalRef(db, `errors/${year}/${month}/${day}/saveOffersDailyStats`);
    await set(errorRef, error.message);
  }
};



const SaveImportedOffers = async (ImportedOffers) => {


 if (ImportedOffers.length > 0) {

 saveImportedOffersDailyStats(ImportedOffers.length)

 try {
    setDownLoading(true);

    const offersToSave = ImportedOffers.filter(offer => offer.selectedToImport === true);

    const savePromises = offersToSave.map((offer) => {
      

      const mediaMap = {
        securityGuarded: 'Ochrona', 
        securityMonitoring: 'Monitoring',
        securityReception: 'Recepcja',
        securityAlarm: 'Alarm',
        securityVideocameras: 'Monitoring'
      };

      const bussinesAdditionsMap = {
        mediaGas: 'Gaz', 
        mediaCurrent: 'Prąd',
        mediaWater: 'Woda',
        mediaInternet: 'Internet',
        mediaSewerage: 'Kanalizacja',
        mediaPhone: 'Telefon',
        mediaTelevision: 'Telewizja kablowa'
      };

      const landMedia = Object.entries(mediaMap)
        .filter(([key]) => offer[key] === 1 || offer[key] === true)
        .map(([_, label]) => label);

      const bussineAdditionsValues = Object.entries(bussinesAdditionsMap)
        .filter(([key]) => offer[key] === 1 || offer[key] === true)
        .map(([_, label]) => label);
    
      const modifiedOffer = {
        ...offer,
        companyName: LoggedUser.name,
        visibility: false,
        option: 'basic',
        MainCategory: trimMainCat(offer.typeName) || null,
        SubCategory: trimSubCat(offer.typeName) || null,
        title: offer.portalTitle || trimMainCat(offer.typeName),
        ImagesUrls: (offer.pictures || []).map(url => ({ uploadedUrl: url })) || null,
        price: fortmatPrice(offer.price) || null,
        squareFootage: offer.areaUsable || offer.areaTotal || null,
        roomsNumber: offer.apartmentRoomNumber || null,
        buildYear: offer.buildingYear || null,
        floor: offer.apartmentFloor || null,
        email: offer.contactEmail || null,
        contact: LoggedUser.PhoneNumber || null,
        cityLatit: offer.locationLatitude || null,
        cityLong: offer.locationLongitude || null,
        city: offer.locationCityName || null,
        district: offer.locationPrecinctName || null,
        street: offer.locationStreetName || null,
        companyDescription: LoggedUser.Description || null,
        addDate: Date.now(),
        balconyNumber: offer.additionalBalcony || null,
        basement: offer.additionalBasement || null,
        building: offer.locationBuildingnumber || null,
        detailViews: 0,
        listViews: 0,
        local: offer.locationApartmentnumber || null,
        market: fortmatMarket(offer.market) || null,
        miniLogoUrl: LoggedUser.MiniLogoUrl || null,
        sellerCity: LoggedUser.City || null,
        sellerLocalNr: LoggedUser.BuildingNr || null,
        sellerStreet: LoggedUser.Street || null,
        sellerZipCode: LoggedUser.ZipCode || null,
        totalFloors: offer.buildingFlooring || null,
        heatingType: offer.buildingHeating || null,
        id: LoggedUser.name + offer.id,
        parkingSpot: trimParking(offer) || null,
        paid: null,
        landHeight: offer.groundPlotheight || null,
        landWidth: offer.groundPlotwidth || null,
        landMedia: bussineAdditionsValues.length ? bussineAdditionsValues : null, // działka dostaje gaz, prad, woda, etc
        bussinesMedia: bussineAdditionsValues.length ? bussineAdditionsValues : null, // biuro dostaje gaz, prad, woda etc
        bussinesAdditions: landMedia.length ? landMedia : null, // bussienesAdditions dostaje ochrona, monitoring etc
      };

      const path = `offers/${LoggedUser.name + offer.id}`;
      return set(PopUpModalRef(db, path), modifiedOffer);
    });

    // Zapis wszystkich ofert
    await Promise.all(savePromises);

    // Ustawienie informacji w modalu
    setModalVersion(2);
    setModalInfo({
      title: 'Import Ofert',
      message: 'Oferty zapisane poprawnie, pojawią się w zakładce zakończone'
    });

  } catch (err) {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');

    await set(PopUpModalRef(db, `errors/${year}/${month}/${day}/SaveImportedOffers`), {
      error: err.message || err.toString(),
      time: now.toISOString()
    });

    alert('Wystąpił błąd podczas zapisywania ofert. Daj nam chwilę, zbadamy problem.');
  } finally {
    setDownLoading(false);
  }
  } else {
    alert('Przed próbą importu zaloguj się do API ersti i pobierz oferty.');
  }
};

const filteredOffers = ImportedOffers.filter((item) => {
  const mainType = item?.typeName
    ? item.typeName.replace(/\s*\(.*?\)\s*/g, '').trim().toLowerCase()
    : '';
  const filter = MainFilter?.toLowerCase() || '';
  return !filter || mainType === filter;
});


  return (
    <div className="OffersImportMainContainer"> 

      { DownLoading ? <FloatingLoading/> : null}

      <h1 className="ModalTitle">{ModalInfo.title}</h1>
      <p className="OffersImportParagraf">EstriCRM</p>
      <p className="OffersImportParagraf">Przed importem ofert upewnij się, że API zostało aktywowane</p>
      <p className="OffersImportParagraf">W tym celu wymagany jest kontakt z pomoc@esticrm.pl</p>
      <p className="OffersImportParagraf">Login oraz token API znajdziesz na stronie Ersti</p>
      <p className="OffersImportParagraf">ustawienia - dane firmowe - hasło API</p>
      <p className="OffersImportParagraf">Przykładowe ID Firmy - 2XXX0</p>
      <p className="OffersImportParagraf">Przykładowy token - dXXXXXXX1c</p>

      <div className="OfferImportUserIDinp">
        <input className="OfferDetailsInputs" placeholder="ID" onChange={handleIDInputChange} value={ID} />
        <input className="OfferDetailsInputs" placeholder="Token" onChange={handleTokenInputChange} value={Token} />

        {ID && Token && (
          <div className="ImportedOffersAvailableStatusesMainContainer">
            <p className="OffersImportParagraf">Wybierz status ofert:</p>
            <div className="ImportedOffersAvailableStatuses">
              {statusOptions.map(({ label, value }) => (
                <label className="ImportedOffersAvailableStatus" key={value}>
                  <input
                    type="checkbox"
                    value={value}
                    checked={statuses.includes(value)}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      setStatuses((prev) =>
                        e.target.checked ? [...prev, val] : prev.filter((s) => s !== val)
                      );
                    }}
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>
        )}

        {Warning && <p>{Warning}</p>}

        <button className="ConfirmBtns" onClick={DownloadOffers}>
          Pobierz oferty
        </button>

        {ImportedOffers.length > 0 && (
          <div className='massSelectOffersContainer'> 
             <button className="ConfirmBtns" onClick={selectAllOffers}>
               Zaznacz wszystkie
             </button>
             <button className="ConfirmBtns" onClick={deSelectAllOffers}>
              Odznacz wszystkie
             </button>
             </div>
        )}

        { ImportedOffers.length > 0 ? 
             <div className='OffersImportMainCatFilters'>
       </div>
       : null
        } 
   

      </div>

    {Array.isArray(ImportedOffers) && ImportedOffers.length > 0 && (
  filteredOffers.length > 0 ? (
    filteredOffers.map((item, index) => (
      <div className="OffersToImportSampleContainer" key={index}>
        <p>ID: {item.id}</p>
        <p>Tytuł: {item.portalTitle}</p>
        {item.pictures && PicturesDisplayer(item.pictures, item)}
        <p>Cena: {CalcSingleOfferPrice(item.price)}</p>
        <p>Miasto: {item.locationCityName}</p>
        <p>Ulica: {item.locationStreetName}</p>

        <div className="SelectImportedOffer">
          <p>Wybierz do importu:</p>
          <label className="CheckboxLabel">
            <input
              type="checkbox"
              checked={!!item.selectedToImport}
              onChange={() => toggleOfferSelection(item.id)}
            />
          </label>
        </div>
      </div>
    ))
  ) : (
    <p style={{ padding: '10px', fontWeight: 'bold' }}>Brak ofert w tej kategorii</p>
  )
)}

      <div className="RemoveLogoBtnsContainer">
        <button className="ConfirmBtns" onClick={() => CloseModal(setShowPopUpModal, setModalVersion, setModalInfo)}>
          Zamknij
        </button>
        <button className="ConfirmBtns" onClick={() => SaveImportedOffers(ImportedOffers)}>
          Importuj
        </button>
      </div>
    </div>
  );
};

export default OffersImport;
